import { render, staticRenderFns } from "./sidebar_reviewers.vue.js?vue&type=template&id=42c128e6&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./sidebar_reviewers.vue?vue&type=template&id=42c128e6&vue3"
import script from "./sidebar_reviewers.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./sidebar_reviewers.vue?vue&type=script&lang=js&vue3"
export * from "./sidebar_reviewers.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./sidebar_reviewers.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports